import { gql } from '@apollo/client';

export const GENERATE_ROUTE_PLANNING_BILL_OF_LADING_PDF_FOR_DSP = gql`
  mutation GenerateRoutePlanningBillOfLadingPdfForDsp($warehouseId: Long!, $taskDate: String!) {
    generateRoutePlanningBillOfLadingPdfForDsp(warehouseId: $warehouseId, taskDate: $taskDate)
  }
`;

export const GENERATE_ROUTE_PLANNING_BILL_OF_LADING_PDF = gql`
  mutation GenerateRoutePlanningBillOfLadingPdf($warehouseId: Long!, $taskDate: String!) {
    generateRoutePlanningBillOfLadingPdf(warehouseId: $warehouseId, taskDate: $taskDate)
  }
`;
